// extracted by mini-css-extract-plugin
export default {"container":"ingredient_container__WuGRq"};